import {Component, Input} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {Rma, RmaResolvedStatus, RmaStatus} from "../../api/model/rma";

@Component({
  selector: 'app-rma-status',
  templateUrl: './rma-status.component.html',
  styleUrls: ['./rma-status.component.sass']
})
export class RmaStatusComponent {
  @Input() condense: Boolean = false;
  @Input() small: Boolean = true;
  @Input() rma!: Rma;

  iconColor(): ThemePalette {
    return this.rma.resolvedStatus === RmaResolvedStatus.COMPLETE ? 'primary' : undefined;
  }

  isYellow(): boolean {
    return this.rma.resolvedStatus === RmaResolvedStatus.ACTIVE;
  }

  isBlue() {
    return this.rma.resolvedStatus === RmaResolvedStatus.HOLD;
  }

  status(): RmaStatus | undefined {
    return this.rma.statuses.at(-1);
  }
}
